import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { ModalBase } from 'morgana';
import { FormGroup, NgForm } from '@angular/forms';
import { _assign } from '@core/lodash/lodash';
import { GandalfFormBuilder } from 'gandalf';
import { AskQuestionRequest } from '@gandalf/model/ask-question-request';
import { SecurityManagerService } from '@core/security-manager/security-manager.service';
import { NavigationMenuService } from '../services/navigation-menu.service';

@Component({
	selector: 'pms-ask-rev-assure-modal',
	templateUrl: './ask-rev-assure-modal.component.html',
	styles: [],
	standalone: false,
})
export class AskRevAssureModalComponent extends ModalBase<null, AskQuestionRequest> implements OnInit {
	private gandalfFormBuilder = inject(GandalfFormBuilder);
	private securityManagerService = inject(SecurityManagerService);
	private navigationMenuService = inject(NavigationMenuService);

	@ViewChild('modal')
	modal: DialogComponent;

	@ViewChild('templateForm')
	templateForm: NgForm;

	formGroup: FormGroup;
	isSaving = false;
	request = new AskQuestionRequest();

	ngOnInit() {
		this.request.emailAddress = this.securityManagerService.getUserSession().userEmail;
		this.formGroup = this.gandalfFormBuilder.group(this.request);
	}

	closeModal() {
		this.dynamicModalRef.close(this.modal, _assign(this.request, this.formGroup.value));
	}

	submitForm(event) {
		this.templateForm.onSubmit(event);
	}

	submit() {
		if (this.formGroup.invalid || this.isSaving) {
			return;
		}
		this.isSaving = true;
		this.navigationMenuService.askRevAssureQuestion(this.formGroup.value).subscribe(() => {
			this.closeModal();
		});
	}
}
